import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Languages } from '../constants/localization';

export enum Currencies {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
}

export const CurrencySymbol = {
  EUR: '€',
  USD: '$',
  GBP: '£',
};

@Pipe({ standalone: true, name: 'wecurrency' })
export class CurrencyPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  public get currentLanguage() {
    return this.translateService.getCurrentLang();
  }

  transform(value: number, inCents: boolean = false, currency: Currencies = Currencies.EUR): string {
    if (!value) {
      return `-- ${CurrencySymbol[currency]}`;
    }
    const amount = inCents ? value / 100 : value;

    return `${amount.toFixed(2)}${CurrencySymbol[currency]}`.replace('.', this.decimalSeparator);
  }

  public get decimalSeparator(): string {
    switch (this.currentLanguage) {
      case Languages.EN_US:
        return '.';
      case Languages.ESP:
        return ',';
      case Languages.ITA:
        return ',';
      default:
        return '.';
    }
  }
}
